import { ChartBarIcon } from '@heroicons/react/16/solid';
import { getGtpClassCountLabel, getGtpItemsFromRow, getGtpSummary } from '@/utils/formatGtpList';

type GtpCellProps = {
  data: any;
  openRowDetails?: () => void;
};

export function GtpCell({ data, openRowDetails }: GtpCellProps) {
  const items = getGtpItemsFromRow(data);

  if (items.length === 0) return <span>-</span>;

  const summary = getGtpSummary(items);
  const countLabel = getGtpClassCountLabel(items);

  return (
    <button
      type="button"
      className="tab-links inline-flex max-w-full items-center gap-1 border-0 bg-transparent p-0 text-left"
      aria-label="View GTP profile"
      title={summary}
      onClick={event => {
        event.stopPropagation();
        if (openRowDetails) {
          openRowDetails();
          return;
        }
        window.dispatchEvent(
          new CustomEvent('disgenet:open-bottom-row-detail', {
            detail: { original: data },
          }),
        );
      }}
    >
      <ChartBarIcon className="h-4 w-4 shrink-0" aria-hidden />
      <span className="truncate">{countLabel}</span>
    </button>
  );
}
